import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import isValidJsonString from '../utils/is-valid-json-string';
import Guid from '../utils/guid';
import { encode } from 'base-64';
import concat from 'lodash/fp/concat';
import { addDays, ymd } from '../utils/date';
import { DOC_UPLOAD } from '../../src/constants';
import moment from 'moment';
import { Base64 } from 'js-base64';

const DOCUPLOAD_PATH = 'roster.data.docupload';

export default () =>
  muster()

    .path('docupload.uploadInitialize', {
      call: async ({ req }, { get, set, call }) => {
        await set('docupload.showErrorModal', false);
        await set('docupload.loading', true);
        const [userId] = await getValues(get('rmAccess.oracleUserId'));
        const [winUserId] = await getValues(get('auth.userId'));
        await set('docupload.winUserId', winUserId);
        if (userId) {
          await set('auth.userId', userId);
        }
        const [messages] = await getValues(get('i18n.messages'));
        const guidStr = Guid();
        const [result] = await getValues(get(`${DOCUPLOAD_PATH}.uploadInit["${guidStr}"]`));
        if (result) {
          await set('docupload.loading', false);
          isValidJsonString(result).then(async (data) => {
            if (data.retCode === "0") {
              await Promise.all([set('docupload.initializeSuccess', true)],
                [set('docupload.acceptances', data.acceptances || [])],
                [set('docupload.statuses', data.status || [])],
                [set('docupload.supportedExtension', data.supportedExtensions)]);
            } else {
              await set('docupload.showErrorModal', true);
              await set('docupload.errorTitle', messages['app.rmAccess.search.error.title']);
              await set('docupload.errorMsg', messages['app.rmAccess.genericError']);
            }
          }).catch(async (e) => {
            await set('docupload.showErrorModal', true);
            await set('docupload.errorTitle', messages['app.rmAccess.search.error.title']);
            await set('docupload.errorMsg', messages['app.rmAccess.genericError']);
            console.log(e);
          });
        }
      }
    })
    .path('docupload.fetchContractsForBp', {
      call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));
        await set('docupload.showErrorModal', false);
        await set('docupload.search.showSpinner', true);
        const inputParam = `${req.args[0]}#@#`;
        const guidStr = Guid();
        const [result] = await getValues(get(`${DOCUPLOAD_PATH}.search["${inputParam}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (data) => {
          await set('docupload.search.showSpinner', false);
          if (data.retCode === "0") {
            await Promise.all([set('docupload.contractDetails', data.contractList || [])]);
            if (data.contractList.length === 0) {
              await set('docupload.showErrorModal', true);
              await set('docupload.errorTitle', messages['app.rmAccess.search.error.title']);
              await set('docupload.errorMsg', messages['app.docUpload.search.invalid.bp.errorMsg']);
            }
          }
          else {
            await set('docupload.showErrorModal', true);
            await set('docupload.errorTitle', messages['app.rmAccess.search.error.title']);
            await set('docupload.errorMsg', messages['app.rmAccess.genericError']);
          }
        }).catch(async (e) => {

          await set('docupload.search.showSpinner', false);
          await set('docupload.showErrorModal', true);
          await set('docupload.errorTitle', messages['app.rmAccess.search.error.title']);
          await set('docupload.errorMsg', messages['app.rmAccess.genericError']);
          console.log(e);
        });
      }
    })

    .path('docupload.finalizeDocUpload ', {
      call: async ({ req }, { get, set, call }) => {
        await set('docupload.finalize.showSpinner', true);
        await set('docupload.finalizeSuccess', false);
        await set('docupload.showErrorModalFinalize', false);
        const base64Contracts = Base64.encode(JSON.stringify(req.args[0]));
        const base64DataObj = Base64.encode(JSON.stringify(req.args[1]));
        const guidStr = Guid();
        const [result] = await getValues(get(`${DOCUPLOAD_PATH}.uploadFinalize["${base64Contracts}"]["${base64DataObj}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (data) => {
          if (data.retCode === "0") {
            await set('docupload.finalizeSuccess', true);
            await set('docupload.finalize.showSpinner', false);
          } else {
            await set('docupload.finalize.showSpinner', false);
            await set('docupload.showErrorModalFinalize', true);
          }
        }).catch(async (e) => {
          await set('docupload.finalize.showSpinner', false);
          await set('docupload.showErrorModalFinalize', true);
          console.log(e);
        })
      }
    })

    .path('docupload.finalizeChunkUpload ', {
      call: async ({ req }, { get, set, call }) => {
        await set('docupload.finalizeChunkSuccess', false);
        await set('docupload.showErrorModalFinalize', false);
        const base64DataObj = encode(JSON.stringify(req.args[0]));
        const guidStr = Guid();
        const [result] = await getValues(get(`${DOCUPLOAD_PATH}.uploadChunkFinalize["${base64DataObj}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (data) => {
          if (data.retCode === "0") {
            await set('docupload.finalizeChunkSuccess', true);
            await set('docupload.docMetaDataId', data.docMetadataId);
          } else {
            await set('docupload.finalizeChunkSuccess', false);
            await set('docupload.showErrorModalFinalize', true);
            await set('docupload.showErrorModal', true);
            await set('docupload.loading', false);
          }
        }).catch(async (e) => {
          await set('docupload.finalizeChunkSuccess', false);
          await set('docupload.showErrorModalFinalize', true);
          await set('docupload.showErrorModal', true);
          await set('docupload.loading', false);
          console.log(e);
        })
      }
    })

    .path('docupload.getUploadHistory', {
      call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));
        await set('docupload.showErrorModal', false);
        await set('docupload.search.showSpinner', true);
        //await set('docupload.errorMsg', false);
        const sortColumn = req.args[0];
        const order = req.args[1];
        const {
          bpId,
          contract,
          name,
          isSelf,
          dateRange: { from, to }
        } = req.args[2];
        const encodeBpId = encode(JSON.stringify(bpId));
        const encodeContract = encode(JSON.stringify(contract));
        const encodeName = encode(JSON.stringify(name));


        const fromDate = ymd(new Date(from));
        const startDate = new Date(fromDate).toISOString()

        const toDate = ymd(new Date(to));
        const endDate = new Date(toDate).toISOString();

        const pageObj = encode(JSON.stringify(req.args[3])) || {};

        const inputParam = `${sortColumn}#@#${order}#@#${encodeBpId}#@#${encodeContract}#@#${encodeName}#@#${isSelf}#@#${startDate}#@#${endDate}#@#${pageObj}`;

        const guidStr = Guid();
        let [previousRecords] = await getValues(get('docupload.historyRecordDetails'));
        const [result] = await getValues(get(`${DOCUPLOAD_PATH}.getUploadHistory["${inputParam}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (data) => {
          if (data.retCode === "0") {
            const RecordData = concat(previousRecords === null ? [] : previousRecords, data.records ?
              data.records : []);
            await set('docupload.historyRecordDetails', RecordData || []);
            await set('docupload.uploadHistory.pagination', data.page ? data.page : {});
            await set('docupload.search.showSpinner', false);
            if (data.records.length === 0) {
              await set('docupload.showErrorModal', true);
              await set('docupload.errorTitle', messages['app.rmAccess.search.error.title']);
              await set('docupload.errorMsg', messages['app.docUpload.uploadHistory.invalid.search.msg']);
            }

          } else {
            await set('docupload.search.showSpinner', false);
            await set('docupload.showErrorModal', true);
            await set('docupload.errorTitle', messages['app.rmAccess.genericErrorTitle']);
            await set('docupload.errorMsg', messages['app.rmAccess.genericError']);
          }
        }).catch(async (e) => {
          await set('docupload.search.showSpinner', false);
          await set('docupload.showErrorModal', true);
          await set('docupload.errorTitle', messages['app.rmAccess.genericErrorTitle']);
          await set('docupload.errorMsg', messages['app.rmAccess.genericError']);
          console.log(e);
        })
      }
    })

    .path('docupload.documentDownload', {
      call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));
        await set('docupload.search.showSpinner', true);
        await set('docupload.showErrorModal', false);
        const docId = req.args[0];
        const docusafeDocId= req.args[1];
        const contract = req.args[2];
        const inputParam = `${docId}#@#${docusafeDocId}#@#${contract}`;
        const guidStr = Guid();
        const [result] = await getValues(get(`${DOCUPLOAD_PATH}.download["${inputParam}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (data) => {
          await set('docupload.search.showSpinner', false);
          if (data.retCode === "0") {
            await set('docupload.downloadedBase64', data.data || "");
            await set('docupload.downloaded.fileName', data.fileName);
            await set('docupload.downloaded.fileType', data.contentType);
          }
          else {
            await set('docupload.showErrorModal', true);
            await set('docupload.errorTitle', messages['app.rmAccess.search.error.title']);
            await set('docupload.errorMsg', messages['app.rmAccess.genericError']);
          }
        }).catch(async (e) => {
          await set('docupload.search.showSpinner', false);
          await set('docupload.showErrorModal', true);
          await set('docupload.errorTitle', messages['app.rmAccess.search.error.title']);
          await set('docupload.errorMsg', messages['app.rmAccess.genericError']);
          console.log(e);
        });
      }
    })

    .path('docupload.lastLoginDetails', {
      call: async ({ req }, { get, set, call }) => {
        const user = await getValues(get('auth.userId'));
        const session = moment(new Date()).format('MMMM Do YYYY, h:mm:ss a');

        set('docupload.userName', user);
        set('docupload.lastSession', session);
      }
    })

    .path('docupload.lastSession', variable(''))
    .path('docupload.userName', variable(''))
    .path('docupload.docTypes', variable([]))
    .path('docupload.acceptances', variable([]))
    .path('docupload.statuses', variable([]))
    .path('docupload.contractDetails', variable([]))
    .path('docupload.search.showSpinner', variable(false))
    .path('docupload.docUploadWizardIndex', variable(0))
    .path('docupload.selectedContractDetails', variable([]))
    .path('docupload.uploadFormData', variable(null))
    .path('docupload.finalizeSuccess', variable(false))
    .path('docupload.finalizeChunkSuccess', variable(false))
    .path('docupload.historyRecordDetails', variable([]))
    .path('docupload.docMetaDataId', variable(''))
    .path('docupload.uploadHistory.pagination', variable({}))
    .path('docupload.showErrorModal', variable(false))
    .path('docupload.showErrorModalFinalize', variable(false))
    .path('docupload.errorMsg', variable(null))
    .path('docupload.errorTitle', variable(null))
    .path('docupload.downloadedBase64', variable(''))
    .path('docupload.downloaded.fileName', variable(''))
    .path('docupload.downloaded.fileType', variable(''))
    .path('docupload.downloadEnable', variable(false))
    .path('docupload.initializeSuccess', variable(false))
    .path('docupload.supportedExtension', variable([]))
    .path('docupload.loading', variable(false))
    .path('docupload.winUserId', variable(''))
    .path('docupload.finalize.showSpinner', variable(false))
